import { Star } from "lucide-react";

export default function StarRating({ value = 0, size = 14, className = "" }) {
  const full = Math.round(value);
  return (
    <div className={`inline-flex items-center gap-0.5 ${className}`} data-testid="star-rating">
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          width={size}
          height={size}
          strokeWidth={1.5}
          className={i <= full ? "fill-gold text-gold" : "text-cream-border"}
        />
      ))}
    </div>
  );
}
